export default "__VITE_ASSET__6813ae70__"